import {bodyLock} from "./module";

export function popups() {
    const _document = this._document;
    const popupLinks = _document.querySelectorAll(".popup-link");
    const popupWrap = _document.querySelector(".popups");
    const popups = _document.querySelectorAll(".popup");
    // const closePopupBtn = _document.querySelector(".popup-close");
    const videoPopup = _document.querySelector(".video-popup") || null;

    [...popupLinks].forEach(popupLink => {
        popupLink.addEventListener("click", event => {
            event.preventDefault();
            openPopup(event.target);
        });
    });

    // closePopupBtn.addEventListener("click", closePopup);

    function openPopup(elem) {
        const _href = elem.getAttribute("href");
        const videoPopup = _document.querySelector(".video-popup");
        const videoPlayer = videoPopup.querySelector(".player");
        bodyLock.lockBody();
        popupWrap.classList.add("active");
        if(elem.classList.contains("video")) {
            const videoTemplate = `<video controls playsinline>
            <source src="${_href}" type="video/mp4">
            Your browser does not support the video tag.
            </video>`;
            videoPopup.classList.add("active");
            videoPlayer.innerHTML = videoTemplate;
            videoPopup.querySelector("video").play();
        } else if(elem.classList.contains("youtube")) {
            const videoTemplate = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${_href}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            videoPopup.classList.add("active");
            videoPlayer.innerHTML = videoTemplate;
        } else {
            _document.querySelector(_href).classList.add("active");
        }

        _document.addEventListener("click", event => {
            if(event.target.classList.contains("popups") || event.target.classList.contains("popup-close")) {
                closePopup();
            }
        });
    }

    function closePopup() {
        popupWrap.classList.remove("active");
        
        [...popups].forEach(popup => {
            popup.classList.remove("active");
        });

        if(videoPopup) {
            videoPopup.querySelector(".player").innerHTML = "";
        }

        bodyLock.unlockBody();
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/popups.js